import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

const sidePadding = 28;

export default {
  container: (isReply) => ({
    width: '100%',
    transition: 'height 0.5s',
    paddingLeft: `${isReply ? '45px' : 0}`,
  }),
  wrapper: {
    width: '100%',
    float: 'left',
  },
  commentWrapper: (isReply) => ({
    width: `calc(100% - ${isReply ? '45px' : '0px'})`,
  }),
  seeComments: (collapsed) => ({
    height: 45,
    width: collapsed ? '100%' : 'calc(100% + 72px)',
    marginLeft: collapsed ? 0 : `-${theme.spacing.xxxLarge}`,
    lineHeight: '45px',
    backgroundColor: collapsed ? 'transparent' : colors.grayLight,
    color: colors.designSystem.purple70,
    cursor: 'pointer',
    transition: 'opacity 0.2s',
    ':hover': {
      opacity: 0.75,
    },
  }),
  seeCommentsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  seeCommentsText: {
    fontSize: 14,
    fontWeight: theme.font.weight.semiBold,
  },
  seeCommentsTextHide: {
    fontSize: 14,
    color: colors.grey6,
    paddingLeft: theme.spacing.xxxLarge,
  },
  seeCommentsCarretWrapper: {
    display: 'inline-block',
    height: 10,
    width: 10,
  },
  seeCommentsCarret: {
    width: 5,
    height: 5,
    marginLeft: 8,
    borderLeft: `2px solid ${colors.designSystem.purple70}`,
    borderBottom: `2px solid ${colors.designSystem.purple70}`,
    transition: 'all 0.3s',
  },
  seeCommentsCarretDown: {
    borderColor: colors.designSystem.purple70,
    transform: 'rotate(-45deg)',
  },
  seeCommentsCarretUp: {
    marginTop: 5,
    borderColor: colors.grey6,
    transform: 'rotate(-225deg)',
  },
  showingCommentNumber: {
    opacity: 1,
    transition: 'opacity 0.2s',
    display: 'inline-block',
    right: sidePadding,
    fontSize: 14,
    color: colors.grayDark,
    paddingRight: '20px',
  },
  showingCommentNumberHidden: {
    opacity: 0,
  },
  loadMore: (isReply) => ({
    margin: '20px 0',
    width: `calc(100% - ${isReply ? '20px' : '27px'})`,
    padding: `0 ${isReply ? '20px' : '27px'}`,
  }),
  loadMoreText: {
    color: colors.designSystem.purple70,
    fontSize: 14,
    fontWeight: theme.font.weight.semiBold,
    cursor: 'pointer',
  },
  spinner: {
    margin: `${sidePadding}px 0px ${sidePadding}px ${sidePadding}px`,
  },
};
